import { render, staticRenderFns } from "./ui-header.vue?vue&type=template&id=2d5d2f22&scoped=true"
import script from "./ui-header.vue?vue&type=script&lang=js"
export * from "./ui-header.vue?vue&type=script&lang=js"
import style0 from "./ui-header.vue?vue&type=style&index=0&id=2d5d2f22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5d2f22",
  null
  
)

export default component.exports